/* globals webkitURL */
require("../../common.lang.json");
require("../../components/imageeditor/imageeditor.lang.json");

var ExifParser = require("exif-parser");

var WHBase = require("@webhare-system/compat/base");
var legacybase = require("@webhare-system/internal/legacybase");
import { Class, Options, Events } from "@webhare-system/frameworks/mootools/core";
var getTid = require("@webhare-tollium/gettid").getTid;

var $todd = require("../support");
var ImageEditor = require("../../components/imageeditor");

var ImgeditDialogController = new Class(
{ Implements: [ Options, Events ]

, screen: null
, dialog: null
, editor: null
, busylock: null
, imageurl: null
, options: { imgsize: null
           , action: 'upload'
           , resetImage: null
           }
, editorsize: null
, activetool: null

, initialize: function(screen, options)
  {
    this.setOptions(options);
    this.screen = screen;

    var desktopsize = screen.displayapp.container.getSize();
    this.editorsize = { x: parseInt(0.7 * desktopsize.x)
                      , y: parseInt(0.9 * desktopsize.y)
                      };
  }

, loadImageBlob: function(blob, settings)
  {
    if (this.busylock)
      return;

    // Take a busy lock during loading
    this.busylock = this.screen.displayapp.getBusyLock();

    this._readImageFile(blob, settings);
  }

, loadImageSrc: function(src, settings)
  {
    if (this.busylock)
      return;

    // Take a busy lock during loading
    this.busylock = this.screen.displayapp.getBusyLock();

    if (src.indexOf("data:") == 0)
    {
      //console.log("Convert image data from data URL to blob");
      var blob = legacybase.dataURItoBlob(src);
      this._readImageFile(blob, settings);
    }
    else
    {
      var request = new XMLHttpRequest();
      request.onload = (function(event)
      {
        //console.log("Received image file as Blob");
        var mimeType = request.getResponseHeader("Content-Type");
        var blob = new Blob([ request.response ], { type: mimeType });
        this._readImageFile(blob, settings);
      }).bind(this);
      request.open("GET", src, true);
      request.responseType = "blob";
      //console.log("Load image file as Blob");
      request.send();
    }
  }

, _readImageFile: function(file, settings)
  {
    var reader = new FileReader();
    var fixorientation = this.editor ? this.editor.fixorientation : this.options.imgsize ? this.options.imgsize.fixorientation : true;

    // Read the image as ArrayBuffer, so we can read its EXIF data
    reader.onload = (function()
    {
      var exifdata;
      try
      {
        if (fixorientation)
        {
          var parser = ExifParser.create(reader.result);
          exifdata = parser.parse();
        }
      }
      catch (e) {}
      //console.log("Parsed EXIF data", exifdata);

      var objecturl = (URL || webkitURL).createObjectURL(file);
      var options = Object.merge({}, { orientation: exifdata && exifdata.tags.Orientation
                                     , mimetype: file.type
                                     , refpoint: null
                                     , filename: ""
                                     }, settings);
      options.orgblob = file;
      this._loadImageUrl(objecturl, options);
    }).bind(this);
    //console.log("Read image file as ArrayBuffer");
    reader.readAsArrayBuffer(file);
  }

, _loadImageUrl: function(url, options)
  {
    var img = new Image(); //FIXME error handler
    img.addEventListener("load", (function()
    {
      (URL || webkitURL).revokeObjectURL(url);

      if (this.editor)
      {
        // The editor dialog is already opened, load the image into the editor
        //console.log("Load image into editor using object URL");
        this.editor.setImg(img, options);
      }
      else
      {
        // If this is an uploaded image which would not be changed by the image resize method, upload it directly
        if (this._skipEditor(img.width, img.height, options.mimetype))
        {
          //console.log("Fire 'done' event to upload the blob");
          this._closeImageEditor(options.orgblob);
        }
        else
        {
          //console.log("Create image editor dialog with object URL");
          this._createDialog();

          // Set image in a delay, so it's set after the relayout when showing the dialog, preventing an initial image resize
          this.editor.setImg.delay(1, this.editor, [ img, options ]);
        }
      }
    }).bind(this));
    img.addEventListener("error", e =>
    {
      console.error("Error loading image in imgeditor <img> element", e);
      if (this.busylock)
        this.busylock.release();
      this.busylock = null;

      $todd.createMessageBox(this.screen.displayapp,
          { title: getTid("tollium:components.imgedit.editor.title")
          , text: getTid("tollium:components.imgedit.messages.corruptimage")
          , icon: "warning"
          , buttons: [ { name: "close", title: getTid("tollium:common.actions.close") }
                     ]
          });
    });
    img.src = url;
  }

, _skipEditor: function(width, height, mimetype)
  {
    //console.log(this.options.action,this.options.imgsize,width,height,mimetype);
    // When editing, show editor
    if (this.options.action == "edit")
      return false;

    return !ImageEditor.resizeMethodApplied(this.options.imgsize, width, height, mimetype);
  }

, _createDialog: function()
  {
    this.dialog = this.screen.displayapp.createScreen(
        { frame:        { bodynode: 'root'
                        , specials: ['okaction','cancelaction']
                        , title: getTid("tollium:components.imgedit.editor.title")
                        , defaultbutton: "okbutton"
                        //, allowresize: true
                        , allowclose: true
                        , width: this.editorsize.x + "px", height: this.editorsize.y + "px"
                        }
        , root:         { type: 'panel', lines: [{items: [ {item:"body"} ], width: "1pr", height: "1pr"}
                                                ,{items: [ {item:"footer"} ]}
                                                ]
                        }
        , body:         { type: 'panel'
                        , lines: [ { title: "", items: [{item:"imageeditor"}], width: "1pr", height: "1pr" }
                                 ]
                        , width: "1pr", height: "1pr"
                        }
        , footer:       { type: 'panel'
                        , lines: [{items: [ {item:"minsizewarning"}
                                          , {item:"maxsizewarning"}
                                          , {item:"status"}
                                          , {item:"progress"}
                                          , {item:"okbutton"}
                                          , {item:"cancelbutton"}
                                          ]}
                                 ]
                        , spacers: { top:true, bottom:true, left:true, right:true }
                        , isfooter: true
                        , width:'1pr'
                        }
        , minsizewarning: { type: 'image', width: "16px", height: "16px", hint: getTid("tollium:components.imgedit.messages.minsizewarning")
                          , imgwidth: 16, imgheight: 16, settings: { imgname: "tollium:status/warning", width: 16, height: 16, color: "b" }
                          , visible: false
                          }
        , maxsizewarning: { type: 'image', width: "16px", height: "16px", hint: getTid("tollium:components.imgedit.messages.maxsizewarning")
                          , imgwidth: 16, imgheight: 16, settings: { imgname: "tollium:status/warning", width: 16, height: 16, color: "b" }
                          , visible: false
                          }
        , status:       { type: 'text', width: "1pr", ellipsis: true, value: "" }
        , progress:     { type: 'progress', width: "150px", max: 0, value: 0, visible: false }
        , okaction:     { type: 'action', hashandler: true, unmasked_events: ['execute'] } //ADDME can we lose the hashandler requirement? perhaps even unmasked_events ?
        , okbutton:     { type: 'button', title: getTid("tollium:common.actions.save"), action: 'okaction' }
        , cancelaction: { type: 'action', hashandler: true, unmasked_events: ['execute'] } //ADDME can we lose the hashandler requirement? perhaps even unmasked_events ?
        , cancelbutton: { type: 'button', title: getTid("tollium:common.actions.cancel"), action: 'cancelaction' }
        , imageeditor:  { type: 'customhtml', width: "1pr", height: "1pr" }
        });
    this.modallayer = this.dialog.node.getElements(".modallayer")[0];

    this.dialog.setMessageHandler("okaction", "execute", this._onEditorOkButton.bind(this));
    this.dialog.setMessageHandler("cancelaction", "execute", this._onEditorCancelButton.bind(this, false));
    this.dialog.setMessageHandler("frame", "close", this._onEditorCancelButton.bind(this, true));

    // Initialize the image editor
    var containercomp = this.dialog.getComponent("imageeditor");
    containercomp.addEvent("resized", this._onEditorResized.bind(this));

    var container = containercomp.getContainer();
    var options = { width: this.editorsize.x
                  , height: this.editorsize.y
                  , imgsize: this.options.imgsize
                  , resourcebase: $todd.resourcebase
                  , getBusyLock: this.screen.displayapp.getBusyLock.bind(this.screen.displayapp)
                  , setStatus: this._setStatus.bind(this)
                  , setProgress: this._setProgress.bind(this)
                  , createScreen: this.screen.displayapp.createScreen.bind(this.screen.displayapp)
                  , setModalLayerOpacity: this._setModalLayerOpacity.bind(this)
                  , editorBackground: "#ffffff url(" + WHBase.config.tollium.checkered_background + ") top left"
                  };
    if (this.options.action == "edit")
    {
      if (this.options.resetImage)
        options.resetImage = this.options.resetImage;
      //ADDME: Drag-n-drop file upload in image editor?
    }

    this.editor = new ImageEditor(container, options);
    this.editor.addEvent("load", this._onEditorReady.bind(this));
    this.editor.toolbar.toElement().addEventListener("modal-opened", this._onEditorOpenTool.bind(this));
    this.editor.toolbar.toElement().addEventListener("modal-closed", this._onEditorCloseTool.bind(this));
  }

, _relayoutDialog: function()
  {
    var frame = this.dialog.getComponent("frame");
    frame.recalculateDimensions();
    frame.relayout();
  }

, _closeDialog: function()
  {
    // Close editor dialog if still present
    if (this.dialog)
      this.dialog.terminateScreen();
    this.dialog = null;

    if (this.editor)
      this.editor.stop();
    this.editor = null;

    // Close busylock if still present
    if (this.busylock)
      this.busylock.release();
    this.busylock = null;
  }

, _setStatus: function(status, warning)
  {
    this.dialog.getComponent("minsizewarning").setVisible(warning === "min");
    this.dialog.getComponent("maxsizewarning").setVisible(warning === "max");
    this.dialog.getComponent("status").setValue(status);
    this._relayoutDialog();
  }

, _setProgress: function(value, max)
  {
    this.dialog.getComponent("progress").onMsgSetValMax({ value: value, max: max });
    this.dialog.getComponent("progress").setVisible(!!max);
    this._relayoutDialog();
  }

, _setModalLayerOpacity: function(opacity)
  {
    this.modallayer.setStyle("opacity", opacity);
  }

  // sendblob true: retrieve image from editor
  // sendblob not null: send sendblob
  // sendblob null: don't send blob
, _closeImageEditor: function(sendblob, callback)
  {
    if (sendblob === true)
    {
      // Retrieve the image from the editor and close the dialog
      this.busylock = this.screen.displayapp.getBusyLock();
      this.editor.getImageAsBlob((function(blob, settings)
      {
        this.fireEvent("done", [ blob, settings, (function()
        {
          if (callback)
            callback();
          this._closeDialog();
        }).bind(this) ]);
      }).bind(this));
    }
    else
    {
      // Upload the given blob and close the dialog
      this.fireEvent("done", [ sendblob, null, (function()
      {
        if (callback)
          callback();
        this._closeDialog();
      }).bind(this) ]);
    }
  }

, _onEditorReady: function(event)
  {
    if (this.busylock)
      this.busylock.release();
    this.busylock = null;
  }

, _onEditorResized: function(data)
  {
    this.editorsize = { x: data.x, y: data.y };
    if (this.editor)
      this.editor.setSize(this.editorsize.x, this.editorsize.y);
  }

, _onEditorOpenTool: function(event)
  {
    this.activetool = event.detail;
    this.dialog.getComponent("okbutton").setTitle(getTid("tollium:common.actions.ok"));
    this.dialog.getComponent("frame").setTitle(getTid/*nocheck*/("tollium:components.imgedit.editor." + this.activetool.panel._imgedittool));
    this._relayoutDialog();
  }

, _onEditorCloseTool: function()
  {
    this.activetool = null;
    this.dialog.getComponent("okbutton").setTitle(getTid("tollium:common.actions.save"));
    this.dialog.getComponent("frame").setTitle(getTid("tollium:components.imgedit.editor.title"));
    this._relayoutDialog();
  }

, _onEditorOkButton: function(data, callback)
  {
    if (this.activetool)
    {
      // Apply the active tool
      this.activetool.apply();
      callback();
    }
    else
    {
      this._closeImageEditor(true, callback);
    }
  }

, _onEditorCancelButton: function(frameclose, data, callback)
  {
    if (this.activetool)
    {
      // Closing the window when a tool is active
      if (frameclose)
      {
        $todd.createMessageBox(this.screen.displayapp,
            { title: getTid("tollium:components.imgedit.editor.title")
            , text: getTid("tollium:components.imgedit.messages.confirmdiscardtool")
            , icon: "warning"
            , buttons: [ { name: "yes", title: getTid("tollium:common.actions.yes") }
                       , { name: "no", title: getTid("tollium:common.actions.no") }
                       ]
            , onclose: function(result)
              {
                if (result == "yes")
                  this._closeImageEditor();
              }.bind(this)
            }).finally(callback);
        return;
      }

      // Cancel the active tool
      this.activetool.cancel();
      callback();
    }
    else
    {
      // Closing the window when the image is edited
      if (this.editor.isDirty())
      {
        $todd.createMessageBox(this.screen.displayapp,
            { title: getTid("tollium:components.imgedit.editor.title")
            , text: getTid("tollium:components.imgedit.messages.confirmdiscardchanges")
            , icon: "warning"
            , buttons: [ { name: "yes", title: getTid("tollium:common.actions.yes") }
                       , { name: "no", title: getTid("tollium:common.actions.no") }
                       , { name: "cancel", title: getTid("tollium:common.actions.cancel") }
                       ]
            , onclose: function(result)
              {
                if (result == "no")
                  this._closeImageEditor();
                else if (result == "yes")
                {
                  this._closeImageEditor(true);
                }
              }.bind(this)
            }).finally(callback);
        return;
      }

      this._closeImageEditor(null, callback);
    }
  }
});

ImgeditDialogController.checkTypeAllowed = function(screen, type)
{
  let allowed_mimetypes = [ "image/jpeg", "image/png", "image/gif" ];
  if (!allowed_mimetypes.includes(type))
  {
    $todd.createMessageBox(screen.displayapp,
        { title: getTid("tollium:components.imgedit.editor.title")
        , text: getTid("tollium:components.imgedit.messages.unsupportedtype")
        , icon: "warning"
        , buttons: [ { name: "close", title: getTid("tollium:common.actions.close") }
                   ]
        });
    return false;
  }
  return true;
};

export default ImgeditDialogController;



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/dialogs/imgeditcontroller.es